import { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Icon } from 'components/core'
import { theme } from 'styles/theme'
import { RootReduxState } from 'types'

import { NavBadge } from './NavBadge'
import { NavButton } from './NavButton'

interface ReportsNavItemProps {
    onClick: () => void
}

export const ReportsNavItem = ({
    onClick,
}: ReportsNavItemProps): ReactElement => {
    const { t } = useTranslation(['common', 'settings'])

    const newReports = useSelector(
        (state: RootReduxState) => state.ui.app.newReports
    )

    return (
        <NavButton
            onClick={onClick}
            tooltipText={t('settings:csvDownload', 'Exports')}
            id="reports-nav-button"
        >
            <Icon name="FILE_DOWNLOAD" size={18} />
            {newReports.length > 0 && (
                <NavBadge
                    count={newReports.length}
                    color={theme.colors.textExtraLight}
                />
            )}
        </NavButton>
    )
}
